import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import __ from 'lodash';
import {Container,Card, Button, Fade, Row, Col, Alert,Form} from 'react-bootstrap';
import Switch from '@material-ui/core/Switch';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import DropdownUploadHistory from '../masterDropDown/DropdownUploadHistory';
import ArraySoalExam from '../../../../entity/ArraySoalExam';
import FilterSoal from '../../../../entity/FilterSoal';
import style from './custom-soal.css';

class ExamSoal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            resMessage: {},
            id: props.match.params.id,
            subProfil: {},
            uploadHis: [],
            soals:[], 
            soalSelected:[], 
            isRenderSoal: false,
            isFetching: false,
            isSearch: false,
            open: false,
            showAlert: false,
            redirect: false,
            filterSekolah: false,
            filterPrime: false,
            searcSoal: {},
            bab: [],
            subBab: [],
            idBab: 0,
            idSubBab: 0,
            subTematik: [],
            pembTematik: [],
            idSubTematik: 0,
            idPembTematik: 0
          };
        this.changeSumber = this.changeSumber.bind(this);  
        this.subBabOnChange = this.subBabOnChange.bind(this);     
        this.babOnChange = this.babOnChange.bind(this);     
        this.subTemaOnChange = this.subTemaOnChange.bind(this);  
        this.pembTematikOnChange = this.pembTematikOnChange.bind(this);           
    }

    async componentDidMount() {  
        document.title = "Soal Exam";      
        this.setState({ isFetching: true });
        await this.props.cekCookies();   
        this.fetchSubprofil(this.state.id)      
        this.fetchUploadHis();  
        this.fetchExamSoal(this.state.id);     
        
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            //script.src = "./Mathjax-2.7.5/MathJax.js?config=TeX-MML-AM_HTMLorMML";   
            script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
        
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';
        
            if (window.opera) {
                script.innerHTML = config
            } else {
                script.text = config
            }
        
            script.addEventListener('load', function() {
                window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
            })
        
            document.getElementsByTagName("head")[0].appendChild(script);
        })();
    }

    async fetchUploadHis() {
        const result = await accountManagement.get(CONFIG.SOAL_GET_UPLOAD_HISTORY)
            .catch(function(error){
                //this.setState({error});
                console.log(error)
            });
        
        if (result) {            
            this.setState({ 
                uploadHis: result.data.data
            });
            
        }         
    }

    renderUploadHis = () => {  
        const {uploadHis} = this.state; 
        if (uploadHis !== null) {    
            return (
                <DropdownUploadHistory uploadHis={uploadHis} />
            )
        }
    }    

    fetchSubprofil = async(id) => { 
        this.setState({ isFetching: true });       
        const result = await accountManagement.get(CONFIG.EXAM_GET_SUBPROFIL_BY_ID + id)
            .catch(function(error){
                console.log(error)
            });
        
        if (result) {            
            this.setState({ 
                subProfil: result.data.data
            });
            if(result.data.data.idMapel !== 0) {
                this.getBab(result.data.data.idMapel);
            } else {
                this.getSubTematik(result.data.data.idTematik);
            }
            
        }
        
    }

    fetchExamSoal = async(id) => {
        this.setState({ isFetching: true });
        const result = await accountManagement.get(CONFIG.EXAM_SOAL_GET + id)
            .catch(function(error){
                console.log(error)
            });
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    soalSelected: result.data.data,
                    open:false
                });
            }
        } 
        this.setState({ isFetching: false });
    }

    async getBab(idMapel){
        this.setState({ isFetching: true, bab:[], subTematik:[] });
        const result = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_BAB +idMapel)
            .catch(function(error){console.log(error)});
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    bab: result.data.data,                    
                });
            }
        } 
    }

    async getSubTematik(idTematik){
        this.setState({ isFetching: true, bab:[], subTematik:[] });
        const result = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBTEMA, {
            params: {idTematik}}).catch(function(error){console.log(error)});
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    subTematik: result.data.data,                    
                });
            }
            this.setState({ isFetching: false });
        } 
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    } 

    subTemaOnChange = async(e) => {
        this.setState({ 
            isFetching: true,
            pembTematik: []
        })

        this.state.idBab = 0;
        this.state.idSubTematik = e.target.value;

        const result = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_PEMBTEMA_SOAL, {
            params: {idSubTematik: e.target.value}}).catch(function(error){console.log(error)});
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    pembTematik: result.data.data,                    
                });
            }
            this.setState({ isFetching: false });
        } 
    }

    babOnChange = async(e) => {
        this.setState({ 
            isFetching: true,
            subBab: []
        })
        this.state.idBab = e.target.value;
        this.state.idSubTematik = 0;

        const result = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBBAB_SOAL + e.target.value)
        .catch(function(error){console.log(error)});
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    subBab: result.data.data,                    
                });
            }
            this.setState({ isFetching: false });
        }
    }

    subBabOnChange = (e) => {      
        this.state.idPembTematik = 0;
        this.state.idSubBab = e.target.value;       
    }

    pembTematikOnChange = (e) => {       
        this.state.idPembTematik = e.target.value;
        this.state.idSubBab = 0;
    }


    filterSoal = () => {
        const {open,subProfil} = this.state;   
        return (
          <>
            <Row>
                <Col>
                    <h3>Soal : {subProfil.nama}</h3>  
                </Col>
                <Col>
                    <Button variant="outline-dark" style={{width: '100%'}}
                    onClick={() => this.setState({ open: !open , filterPrime: false, filterSekolah: true})}
                    aria-controls="example-fade-text"
                    aria-expanded={open}
                    > Open Soal</Button>
                </Col>
                <Col>
                    <Button variant="outline-danger pull-right" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.setState({ redirect: true })}}>
                        Keluar <i className="fa fa-arrow-right"></i></Button>                                     
                </Col>
            </Row>
            {open ? 
            <Fade in={open}>
            <Card style={{marginTop: '10px'}}>             
                <Card.Body>
                <Row>
                    <div className="form-group col-sm-2">Pilih Sumber Soal :</div>  
                    <div className="form-group col-sm-2">
                        <select className="form-control" name="sumber" id="sumber" onChange={this.changeSumber} ref={this.sumber}>
                            <option value="PSEP">Sekolah</option>
                            <option value="PRIME">Eduprime</option>                            
                        </select>
                    </div>  
                </Row>
                
                {this.state.filterPrime && 
                <>
                {subProfil.idMapel !== 0 &&
                <Row>                    
                    <Col>
                        <div className="form-group">
                            <label htmlFor="Bab">Bab :</label>
                            <select className="form-control" name="bab" id="bab" 
                                value={this.state.idBab} onChange={this.babOnChange}>
                                <option value="0">Pilih Bab...</option>
                                {this.state.bab.map((data,i) => 
                                    <option key={i} value={data.idBab}>{data.namaBab}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-group">
                            <label htmlFor="Sub Bab">Sub Bab :</label>
                            <select className="form-control" name="subbab" id="subbab"
                                defaultValue={this.state.idSubBab} onChange={this.subBabOnChange}>
                                <option value="0">Pilih Sub Bab...</option>
                                {this.state.subBab.map((data,i) => 
                                    <option key={i} value={data.idSubBab}>{data.namaSubBab}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                    <input type="hidden" id="mapel" value={subProfil.idMapel} />
                    <input type="hidden" id="upload" value="0" />
                </Row>
                }

                {subProfil.idTematik !== 0 &&
                <Row>                    
                    <Col>
                        <div className="form-group">
                            <label htmlFor="Sub Tematik">Sub Tematik :</label>
                            <select className="form-control" name="subTematik" id="subTematik" 
                                value={this.state.idSubTematik} onChange={this.subTemaOnChange}>
                                <option value="0">Pilih Sub Tematik...</option>
                                {this.state.subTematik.map((data,i) => 
                                    <option key={i} value={data.idSubTematik}>{data.namaSubTematik}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-group">
                            <label htmlFor="Pemb Tematik">Pembelajaran Tematik :</label>
                            <select className="form-control" name="pembTematik" id="pembTematik"
                                defaultValue={this.state.idPembTematik} onChange={this.pembTematikOnChange}>
                                <option value="0">Pilih Pembelajaran Tematik...</option>
                                {this.state.pembTematik.map((data,i) => 
                                    <option key={i} value={data.idPembTematik}>{data.namaPembTematik}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                    <input type="hidden" id="tematik" value={subProfil.idTematik} />
                    <input type="hidden" id="upload" value="0" />
                </Row>
                }
                </>
                }                

                {this.state.filterSekolah && <Row>
                    <Col sm={6}>
                        <div className="form-group">
                            <label htmlFor="upload">Upload History :</label>
                            <select className="form-control" name="upload" id="upload">
                                <option value="0">Pilih Upload History...</option>
                                {this.renderUploadHis()}
                            </select>
                        </div>
                    </Col>
                    <input type="hidden" id="kurikulum" value="0" />
                    <input type="hidden" id="kelas" value="0" />
                    <input type="hidden" id="mapel" value="0" />
                    <input type="hidden" id="bab" value="0" />
                    <input type="hidden" id="subbab" value="0" />
                </Row>}

                <div>
                    <Button variant="outline-dark btn-lg" 
                    onClick={() => {this.btnTampil()} }
                    >Tampilkan Soal</Button>
                </div>
                </Card.Body>
            </Card>           
            
            </Fade>
            : ''}
          </>
        );
    }
    
    renderSoal = () => {         
        const {open, soals, soalSelected} = this.state; 
        const scroll = {
            overflow: 'auto',
            maxHeight: '400px'
        };

        let noPilgan = 1;
        let noEssay = 1;
        if(!open) { 
            
            return (
                <Row style={{ marginTop: '10px'}}>
                    <Col sm={7} style={{marginBottom: '30px'}}> 
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a className="nav-link active" data-toggle="tab" href="#pilgan">Pilihan Ganda</a>
                        </li>
                        {this.state.subProfil.essay !== 0 &&
                        <li className="nav-item">
                            <a className="nav-link" data-toggle="tab" href="#essay">Essay</a>
                        </li>
                        }
                    </ul>
                    <div className="tab-content">
                        <div className="tab-pane active" id="pilgan">
                            <table className="table">
                                <tbody>
                                {soals.map((soal,i) => 
                                    (soal.tipeSoal === 'MULTIPLE' &&
                                    <tr key={soal.idBankSoal}>
                                        <td width="10px"><p>{noPilgan++}.</p></td>
                                        <td>
                                            <div id="accordion">                                        
                                            <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>
                                            <span className="text-primary" data-toggle="collapse" href={'#soal' + soal.idBankSoal} aria-expanded="true" style={{ cursor: 'pointer'}}>details..</span>
                                            <div id={'soal' + soal.idBankSoal} className="collapse" data-parent="#accordion">
                                            <table className="table">
                                                <tbody>
                                                <tr style={{backgroundColor: soal.kunciJawaban == "1" ? "antiquewhite": ""}} >
                                                    <td width="10px"><p>A.</p></td>
                                                    <td dangerouslySetInnerHTML={{__html: soal.jawab1}}></td>
                                                </tr>
                                                <tr style={{backgroundColor: soal.kunciJawaban == "2" ? "antiquewhite": ""}} >
                                                    <td><p>B.</p></td>
                                                    <td dangerouslySetInnerHTML={{__html: soal.jawab2}}></td>
                                                </tr>
                                                <tr style={{backgroundColor: soal.kunciJawaban == "3" ? "antiquewhite": ""}} >
                                                    <td><p>C.</p></td>
                                                    <td dangerouslySetInnerHTML={{__html: soal.jawab3}}></td>
                                                </tr>
                                                <tr style={{backgroundColor: soal.kunciJawaban == "4" ? "antiquewhite": ""}} >
                                                    <td><p>D.</p></td>
                                                    <td dangerouslySetInnerHTML={{__html: soal.jawab4}}></td>
                                                </tr>
                                                <tr style={{backgroundColor: soal.kunciJawaban == "5" ? "antiquewhite": ""}} >
                                                    <td><p>E.</p></td>
                                                    <td dangerouslySetInnerHTML={{__html: soal.jawab5}}></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>
                                                    <p>Pembahasan:</p>
                                                    <span dangerouslySetInnerHTML={{__html: soal.isianJawaban}}></span>
                                                    </td>
                                                </tr>
                                                </tbody>   
                                            </table>
                                            </div>
                                            </div>
                                        </td>
                                        <td width="10px">                                            
                                            <Switch color="secondary" value={soal.idBankSoal} 
                                            onChange={e => this.handleChange(e)}
                                            defaultChecked={ soalSelected.find(val => val.idBankSoal == soal.idBankSoal ? true : false)} />
                                        </td>                                   
                                    </tr>
                                    )
                                )}   
                                </tbody>
                            </table>
                                                            
                        </div>  
                        <div className="tab-pane" id="essay">
                            {/* {this.state.subProfil.essay === 0 ? <h6><br/>Mohon isi Prosentase Essay pada Proses Set Mata Pelajaran...</h6> : */}
                            <table className="table">
                                <tbody>
                                {soals.map((soal,i) => 
                                    (soal.tipeSoal === 'ESSAY' &&
                                    <tr key={soal.idBankSoal}>
                                        <td width="10px"><p>{noEssay++}.</p></td>
                                        <td>
                                            <div id="accordion">                                        
                                            <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>
                                            <span className="text-primary" data-toggle="collapse" href={'#soal' + soal.idBankSoal} aria-expanded="true" style={{ cursor: 'pointer'}}>details..</span>
                                            <div id={'soal' + soal.idBankSoal} className="collapse" data-parent="#accordion">
                                            <table className="table">
                                                <tbody>                                                
                                                <tr>
                                                    <td colSpan={2}>
                                                    <p>Pembahasan:</p>
                                                    <span dangerouslySetInnerHTML={{__html: soal.isianJawaban}}></span>
                                                    </td>
                                                </tr>
                                                </tbody>   
                                            </table>
                                            </div>
                                            </div>
                                        </td>
                                        <td width="10px">                                            
                                            <Switch color="secondary" value={soal.idBankSoal} 
                                            onChange={e => this.handleChange(e)}
                                            defaultChecked={ soalSelected.find(val => val.idBankSoal == soal.idBankSoal ? true : false)} />
                                        </td>                                   
                                    </tr>
                                    )
                                )}   
                                </tbody>
                            </table>
                        
                        </div>
                    </div>
                    </Col>                

                    <Col sm={5}> 
                        <div style={{position:'fixed'}}>
                            <Card >
                                <Card.Header>Soal Selected: {soalSelected.length}</Card.Header>
                                <div style={scroll}>
                                <table className="table">
                                    <tbody id="cek">
                                        {soalSelected.map((sol, i) =>
                                        <tr key={sol.idBankSoal}>
                                            <td><p>{i+1}.</p></td>
                                            
                                        <td><span dangerouslySetInnerHTML={{__html: sol.pertanyaan}}></span></td>                                    
                                        </tr>
                                        )}
                                    </tbody>
                                </table>    
                                </div>         
                            </Card>

                            <Col className="text-center" style={{ marginTop: '20px'}}> 
                                
                                <input type="hidden" name="idProfilCbt" value={this.state.subProfil.idProfilCbt}/>     
                                <input type="hidden" name="idSubProfilCbt" value={this.state.subProfil.idSubProfilCbt}/>                
                                <input type="hidden" name="arraySoal" value={soalSelected.map(v => v.idBankSoal)} />
                                {soalSelected.length > 0 && 
                                    <Button variant="primary" type="submit" style={{width:'100%'}}
                                    onClick={() => {if (window.confirm('Konfirmasi Simpan ?')) this.handleSubmit() }}>Simpan <i className="fa fa-save"></i>
                                    </Button> 
                                }
                            </Col>  
                        </div> 
                    </Col>
                </Row>
            )               
        }
    }

    renderAler = () => {
        const { showAlert,resMessage } = this.state;
      
        if (showAlert) {
          return (
            <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>   
                <strong>{resMessage.errorMessage}</strong>
            </Alert>
          );
        } 
    }

    btnTampil = async(e) => {  
        this.setState({ isFetching: true, showAlert: false , soals: []});   
        
        const result = await accountManagement.post(CONFIG.SOAL_FILTERSOAL, {...FilterSoal,            
            ['idMapel']: this.state.subProfil.idMapel,
            ['idBab']: this.state.idBab,
            ['idSubBab']: this.state.idSubBab,
            ['idTematik']: this.state.subProfil.idTematik,
            ['idSubTematik']: this.state.idSubTematik,
            ['idPembTematik']: this.state.idPembTematik,
            ['idUploadHis']: document.getElementById('upload').value,
            ['kodeOwner']: document.getElementById('sumber').value
        }).catch(function(error){
            console.log(error)
        });
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    soals: result.data.data
                });   
            } else {
                this.setState({
                    resMessage: result.data.errorSchema
                })
            }          
        } 
        this.setState({ isFetching: false, open: false });  
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]); 
    }

    handleChange(e) {        
        let isChecked = e.target.checked;
        let value = e.target.value;
        const { soals,soalSelected } = this.state;
        // do whatever you want with isChecked value         
        if(isChecked) {
            soals.map( soal => {
                if (soal.idBankSoal == value) {                    
                    this.setState(prevState => ({
                        soalSelected: [...prevState.soalSelected, soal]
                      }));
                } 
            })
            
        } else {
            this.setState({ 
                soalSelected: soalSelected.filter(v => v.idBankSoal != value)
            });
        } 
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);        
    }

    handleSubmit = async() => {        
        this.setState({isFetching: true});
        const {subProfil, soalSelected} = this.state
        
        const response = await accountManagement.post(CONFIG.EXAM_ADD_SOAL, {...ArraySoalExam,
            ["idProfilCbt"]: subProfil.idProfilCbt,
            ["idSubProfilCbt"]: subProfil.idSubProfilCbt,
            ["arraySoal"]: soalSelected.map(val => val.idBankSoal)
        }).catch(function(error){
            console.log(error)
        });        
        
        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    resMessage: response.data.errorSchema,
                    redirect: true
                })                
            } else {
                this.setState({
                    resMessage: response.data.errorSchema
                })
                this.setState({isFetching: false});
            }            
        }
    }

    changeSumber(e) {
        let value = e.target.value;        
        if(value == 'PRIME') {
            this.setState({
                filterPrime: true,
                filterSekolah: false
            })
        } else {
            this.setState({
                filterPrime: false,
                filterSekolah: true
            })
        }    
    }

    render() { 
        const { error, resMessage, redirect } = this.state;  
        const source = this.props.match.params.source;     
        
        if(redirect){            
            return( <Redirect to={'/' + source } />)
        }      
        if(error){
            return (
                <div><h2 className="text-danger">Error: {error.message}</h2></div>
              )
        } else {
            return(
                <>
                <Container fluid style={{ marginTop: '20px' }}>
                <LoaderModal isFetching={this.state.isFetching} />
                {this.state.showAlert && 
                <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>   
                    <strong>{resMessage.errorMessage}</strong>
                </Alert>}
                {this.loading()}
                {this.filterSoal()}
                {this.renderSoal()}
                </Container>
                </>
            
            )
        }
    }

}

const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(ExamSoal);